import { Typography } from 'kl-b2c-ui-kit';
import styled, { css } from 'styled-components';
import { mediaSm } from 'theme/theme-helper-selectors';

export const Container = styled.div<{ index: number }>`
    padding: 20px;
    background-color: #f4f7fa;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    ${({ index }) =>
        index === 1
            ? css`
                  grid-column: 2 / 4;
              `
            : index === 2
            ? css`
                  grid-column: 1 / 3;
              `
            : css``}
    @media (${mediaSm}) {
        grid-column: 1/4;
    }
`;

export const DescriptionPart = styled.div<{ fullWidth?: boolean }>`
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
    ${({ fullWidth }) =>
        fullWidth &&
        css`
            width: 50%;
        `}
    @media (${mediaSm}) {
        width: 100%;
    }
`;

export const Title = styled(Typography)`
    padding-bottom: 20px;
    font-weight: 400;
`;

export const Description = styled(Typography)`
    padding-bottom: 20px;
    color: rgba(42, 53, 65, 0.7);
`;

export const ImageContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-end;
`;
export const Image = styled.div<{ imageUrl: string; fullWidth?: boolean }>`
    background-image: url(${({ imageUrl }) => imageUrl});
    width: 300px;
    height: 300px;
    flex: 1;
    background-repeat: no-repeat;
    background-position-x: right;
    background-size: contain;
    margin-bottom: -20px;
    margin-right: -20px;
    ${({ fullWidth }) =>
        fullWidth &&
        css`
            width: 450px;
            height: 450px;
            margin-top: -200px;
        `}
    @media (${mediaSm}) {
        width: 240px;
        height: 240px;
        margin-top: 0px;
    }
`;
